import { makeStyles } from '@material-ui/core/styles'
const StylesWithMaterialUi = makeStyles(() => ({
  helperText: {
    fontFamily: 'Poppins',
  },
}))
export default StylesWithMaterialUi
